//* Config imports
import { api, getAuthHeaders } from "../../config/api";

//* Types imports
import { PhaseFormOutputDTO, Subprocess } from "./types";

const PHASE_FORM_BASE_URL = "/phaseforms";

export const phaseFormService = {
  getAll: () =>
    api.get<PhaseFormOutputDTO[]>(PHASE_FORM_BASE_URL, {
      headers: getAuthHeaders(),
    }),
  getById: (id: string, clientId?: string) =>
    api.get<PhaseFormOutputDTO>(`${PHASE_FORM_BASE_URL}/${id}`, {
      headers: getAuthHeaders(),
      params: clientId ? { clientId } : undefined,
    }),
  getByProductId: (productId: string) =>
    api.get<PhaseFormOutputDTO[]>(
      `${PHASE_FORM_BASE_URL}/product/${productId}`,
      {
        headers: getAuthHeaders(),
      },
    ),
  create: (data: Partial<PhaseFormOutputDTO>) =>
    api.post<PhaseFormOutputDTO>(PHASE_FORM_BASE_URL, data, {
      headers: getAuthHeaders(),
    }),
  update: (id: string, data: Partial<PhaseFormOutputDTO>) =>
    api.put<PhaseFormOutputDTO>(`${PHASE_FORM_BASE_URL}/${id}`, data, {
      headers: getAuthHeaders(),
    }),
  delete: (id: string) =>
    api.delete(`${PHASE_FORM_BASE_URL}/${id}`, {
      headers: getAuthHeaders(),
    }),

  // Subprocess operations
  createSubprocess: (phaseId: string, data: Partial<Subprocess>) =>
    api.post<Subprocess>(
      `${PHASE_FORM_BASE_URL}/${phaseId}/subprocesses`,
      data,
      {
        headers: getAuthHeaders(),
      },
    ),

  deleteSubprocess: (phaseId: string, subprocessId: string) =>
    api.delete(
      `${PHASE_FORM_BASE_URL}/${phaseId}/subprocesses/${subprocessId}`,
      {
        headers: getAuthHeaders(),
      },
    ),

  createMultilineSubprocesses: (
    phaseId: string,
    fieldId: string,
    values: string[],
  ) =>
    api.post<Subprocess[]>(
      `${PHASE_FORM_BASE_URL}/${phaseId}/fields/${fieldId}/subprocesses`,
      { values },
      {
        headers: getAuthHeaders(),
      },
    ),

  updateSubprocessStatus: (
    phaseId: string,
    subprocessId: string,
    status: string,
  ) =>
    api.patch(
      `${PHASE_FORM_BASE_URL}/${phaseId}/subprocesses/${subprocessId}/status`,
      { status },
      {
        headers: getAuthHeaders(),
      },
    ),

  getSubprocesses: (phaseId: string, page: number = 1, limit: number = 10) =>
    api.get<{ items: Subprocess[]; total: number }>(
      `${PHASE_FORM_BASE_URL}/${phaseId}/subprocesses`,
      {
        params: { page, limit },
      },
      {
        headers: getAuthHeaders(),
      },
    ),
};
